export default __webpack_public_path__ + "static/media/start-colored.00093966.svg";